/**
 * UI Reducer for First Processing Page
 * Manages all UI state with typed actions
 */

import { FirstProcessingUIState, FirstProcessingUIAction } from '../types/firstProcessing.types';

/**
 * Initial UI state
 */
export const initialUIState: FirstProcessingUIState = {
  currentStep: 1,
  completedSteps: [],
  isNameModalOpen: false,
  saveDataName: '',
  errorMessages: [],
  successMessage: null,
  isSaving: false,
  isProcessing: false,
  showFileUpload: true,
  showActionButtons: true,
  errorCode: null,
  errorSuggestion: null,
  showUpgradeModal: false,
  upgradeMessage: '',
  upgradeResourceType: 'processing',
  decimalPrecision: 'full',
};

/**
 * UI Reducer function
 */
export const uiReducer = (
  state: FirstProcessingUIState,
  action: FirstProcessingUIAction
): FirstProcessingUIState => {
  switch (action.type) {
    case 'SET_STEP':
      return { ...state, currentStep: action.payload };

    case 'MARK_STEP_COMPLETED':
      return {
        ...state,
        completedSteps: state.completedSteps.includes(action.payload)
          ? state.completedSteps
          : [...state.completedSteps, action.payload]
      };

    case 'TOGGLE_MODAL':
      return { ...state, isNameModalOpen: action.payload };

    case 'SET_SAVE_NAME':
      return { ...state, saveDataName: action.payload };

    case 'ADD_ERROR':
      return {
        ...state,
        errorMessages: [...state.errorMessages, action.payload],
        successMessage: null
      };

    case 'CLEAR_ERRORS':
      return { ...state, errorMessages: [], errorCode: null, errorSuggestion: null };

    case 'SET_SUCCESS':
      return { ...state, successMessage: action.payload, errorMessages: [] };

    case 'SET_SAVING':
      return { ...state, isSaving: action.payload };

    case 'SET_PROCESSING':
      return {
        ...state,
        isProcessing: action.payload,
        showFileUpload: !action.payload,
        showActionButtons: !action.payload
      };

    case 'SET_ERROR_PAYLOAD':
      return {
        ...state,
        errorMessages: [action.payload.message],
        errorCode: action.payload.code ?? null,
        errorSuggestion: action.payload.suggestion ?? null,
        successMessage: null,
      };

    case 'SET_UPGRADE_MODAL':
      return {
        ...state,
        showUpgradeModal: action.payload.open,
        upgradeMessage: action.payload.open
          ? (action.payload.message ?? state.upgradeMessage)
          : state.upgradeMessage,
        upgradeResourceType: action.payload.open
          ? (action.payload.resourceType ?? state.upgradeResourceType)
          : state.upgradeResourceType,
      };

    case 'SET_DECIMAL_PRECISION':
      return { ...state, decimalPrecision: action.payload };

    case 'RESET_UI':
      return initialUIState;

    case 'RESET_UI_WITH_SUCCESS':
      return { ...initialUIState, successMessage: action.payload };

    default:
      return state;
  }
};
